module.exports = __webpack_public_path__ + "static/img/klid.776f792.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/klid.jpg
// module id = QBt/
// module chunks = 0